import SoftBadge from "../../components/SoftBadge";
import PropTypes from "prop-types";

const Badge = ({color, badgeContent, variant, onClick = () => {}}) => {

    return (
        <SoftBadge variant={variant} color={color} badgeContent={badgeContent} size="xs" container  onClick={onClick} sx={{ cursor: "pointer" }}/>
    );

}

Badge.propTypes = {
    variant: PropTypes.string,
    color: PropTypes.string,
    badgeContent: PropTypes.string,
    onClick: PropTypes.func,
}
export default Badge;